import { UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  renderFieldTemplateOne,
} from "./PlantillasBloquesTabla"

export const PlantillaDeclaracion = ({
  fields,
  setValue,
  isDeclaracion190,
  isDeclaracion349,
}: {
  fields: FieldTemplateOne[]
  setValue: UseFormSetValue<$TSMigrationFixMe>
  isDeclaracion190?: boolean
  isDeclaracion349?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <div
      title='Resumen datos incluidos'
      className='tw-w-full tw-px-6'
    >
      <div className='tw-flex tw-flex-col'>
        {isDeclaracion349 && (
          <div className='tw-space-y-3 tw-pb-3 tw-border-b tw-border-gray-200'>
            <p className='tw-text-sm'>
              {t("declaracionModelo349.complemementariaSustitutiva.textOne")}
            </p>
            <p className='tw-text-sm'>
              {t("declaracionModelo349.complemementariaSustitutiva.textTwo")}
            </p>
            <p className='tw-text-sm'>
              {t("declaracionModelo349.complemementariaSustitutiva.textThree")}
            </p>
          </div>
        )}
        {fields.map((field) => renderFieldTemplateOne(field, setValue))}
        {isDeclaracion190 ? (
          <div className='tw-py-1 tw-border-b tw-border-gray-200 tw-text-xs'>
            {t("modelo190.dataSummary.box4")}
          </div>
        ) : null}
      </div>
    </div>
  )
}
